export default {
  cloudinary: {
    cloudName: "richardhaines",
    publicId: "corgi1",
  },
};
